import { OrderedLineItemOut } from '../../store/api';
import {
    PRODUCT_CLASS_CAMPAIGN,
    PRODUCT_CLASS_LANGUAGE_LEARNING,
    PRODUCT_CLASS_LOCAL,
    PRODUCT_CLASS_LOTE,
    PRODUCT_CLASS_STANDARD,
    ProductClass
} from '../../store/constants';
import { LoanFormat, mapLoanFormat } from '../../../models/LoanFormat';
import { mapListProductPriceOutToPrice, mapValidItems } from '../mapping';
import { FetchOrderProductsLineItem } from './fetchOrder';
import {
    isNotBlank,
    isOneOf,
    isPresent,
    isValueOf,
    validateAll,
    validateAndLogOnErrors,
    validateField
} from '../validation';

const validateId = validateAll(isPresent, isNotBlank);

const validateProductClass = validateAll(
    isPresent,
    isOneOf(
        PRODUCT_CLASS_STANDARD,
        PRODUCT_CLASS_CAMPAIGN,
        PRODUCT_CLASS_LOTE,
        PRODUCT_CLASS_LANGUAGE_LEARNING,
        PRODUCT_CLASS_LOCAL
    )
);

const validateLoanFormat = validateAll(isPresent, isValueOf(LoanFormat));

const orderedLineItemOutValidation = validateAll<OrderedLineItemOut>(
    validateField('id', validateId),
    validateField('productClass', validateProductClass),
    validateField('loanFormat', validateLoanFormat)
);

const isLineItemValid = (lineItem: OrderedLineItemOut): boolean => {
    return validateAndLogOnErrors(orderedLineItemOutValidation, lineItem);
};

export const mapOrderProductsToLineItems = (
    orderedLineItems?: ReadonlyArray<OrderedLineItemOut>
): ReadonlyArray<FetchOrderProductsLineItem> => {
    if (!orderedLineItems) {
        return [];
    }

    return mapValidItems(orderedLineItems, isLineItemValid, product => ({
        ...product,
        id: product.id!,
        productClass: product.productClass as ProductClass,
        loanFormat: mapLoanFormat(product.loanFormat)!,
        salesStatus: { key: product.salesStatus },
        price: mapListProductPriceOutToPrice(product.price)
    }));
};
